import Vuex from "vuex";
import Vue from "vue";
import largeSidebar from "./modules/largeSidebar";
import compactSidebar from "./modules/compactSidebar";
import chat from "./modules/chat";
import themeConfig from "./modules/themeConfig";
import authData from "./modules/authData";
import invoice from "./modules/invoice";
import cart from "./modules/cart";
import verticalSidebar from "./modules/verticalSidebar";
import scrumboard from "./modules/scrumboard";

// SILVER STORE
import doctorPanel from "../silver/store/modules/doctorPanel";
import loginSilver from "../silver/store/modules/login";
import branchesSilver from "../silver/store/modules/branches";
import profileSilver from "../silver/store/modules/profileMenu";
import loggedUserSilver from "../silver/store/modules/loggedUser";
import pollingWorkplaceSilver from "../silver/store/modules/pollingWorkplace";
import workstationTurnSilver from "../silver/store/modules/workstationTurn";
import videoCallSilver from "../silver/store/modules/videoCall";
import typifySilver from "../silver/store/modules/typify";
import queuedSilver from "../silver/store/modules/queued";
import customerSilver from "../silver/store/modules/customerDetail";
import customerTypesSilver from "../silver/store/modules/customerTypes";
import derivateSilver from "../silver/store/modules/derivate";
import typesByCompanySilver from "../silver/store/modules/typesByCompany";
import pushNotificationSilver from "../silver/store/modules/pushNotifications";
import environmentSilver from "../silver/store/modules/environment";
import appointmentSilver from "../silver/store/modules/appointments";
import recordersSilver from "../silver/store/modules/recorder";

// Load Vuex
Vue.use(Vuex);

// Create store
export default new Vuex.Store({
  modules: {
    largeSidebar,
    compactSidebar,
    chat,
    themeConfig,
    authData,
    invoice,
    cart,
    doctorPanel,
    verticalSidebar,
    scrumboard,

    loginSilver,
    branchesSilver,
    profileSilver,
    loggedUserSilver,
    pollingWorkplaceSilver,
    workstationTurnSilver,
    videoCallSilver,
    typifySilver,
    queuedSilver,
    customerSilver,
    customerTypesSilver,
    derivateSilver,
    typesByCompanySilver,
    pushNotificationSilver,
    environmentSilver,

    appointmentSilver,
    recordersSilver
  },
});
